import type { ContentPack } from '../engine/pack';

/**
 * 코어 팩 1.0.0 — 전량 자체 창작(ADR-004).
 * 웃김의 최종 판정은 사람이 한다 — 아래 24제는 규격을 통과한 '채택 후보'이며,
 * 개발자가 직접 골라 교체한다. 교체 시 packHash 가 바뀌므로 version 을 함께 올린다.
 * 분포 {2글자:6, 3글자:12, 4글자:6} 은 WORD_LEN_PROFILE × 3판과 정확히 맞물린다.
 */
export const PACK_CORE_1_0_0: ContentPack = {
  id: 'core',
  version: '1.0.0',
  questions: [
    {
      id: 'c001',
      q: '라면이 밤마다 잠들지 못하는 이유는?',
      a: '불면',
      d: ['물', '벌', '먼', '변', '명'],
      tags: ['homonym', 'food', 'd2'],
    },
    {
      id: 'c002',
      q: '야근 끝나고 올려다본 밤하늘, 기분이 어떨까?',
      a: '별로',
      d: ['벌', '볼', '노', '도', '료'],
      tags: ['homonym', 'work', 'd2'],
    },
    {
      id: 'c003',
      q: '눈이 펑펑 오는 날 제일 붐비는 병원은?',
      a: '안과',
      d: ['알', '언', '완', '가', '관', '와', '좌'],
      tags: ['homonym', 'weather', 'd2'],
    },
    {
      id: 'c004',
      q: '1초도 쉬지 않고 키가 줄어드는 것은?',
      a: '양초',
      d: ['앙', '영', '향', '조', '추'],
      tags: ['homonym', 'object', 'd2'],
    },
    {
      id: 'c005',
      q: '지각할 때마다 날아오는 곤충은?',
      a: '벌금',
      d: ['별', '발', '범', '감', '곰'],
      tags: ['homonym', 'animal', 'd1'],
    },
    {
      id: 'c006',
      q: '문 앞에 놓인 택배가 매일 건네는 인사는?',
      a: '문안',
      d: ['무', '눈', '만', '언', '인'],
      tags: ['homonym', 'home', 'd3'],
    },
    {
      id: 'c007',
      q: '에어팟 한 짝만 남은 사람을 뭐라고 부를까?',
      a: '외톨이',
      d: ['회', '쇠', '뇌', '괴', '돌', '탈', '리'],
      tags: ['compound', 'device', 'd1'],
    },
    {
      id: 'c008',
      q: '모기가 SNS에서 좋아요 대신 누르는 버튼은?',
      a: '물어요',
      d: ['불', '무', '아', '여', '유'],
      tags: ['homonym', 'animal', 'd2'],
    },
    {
      id: 'c009',
      q: '한밤중에 흑역사가 떠오를 때 나오는 격투기는?',
      a: '이불킥',
      d: ['미', '물', '부', '킹', '칵'],
      tags: ['slang', 'home', 'd1'],
    },
    {
      id: 'c010',
      q: '월요일 아침에만 유행하는 음악 장르는?',
      a: '블루스',
      d: ['불', '플', '로', '류', '즈'],
      tags: ['loanword', 'work', 'd2'],
    },
    {
      id: 'c011',
      q: '말이 제일 많은 동물원에서 여는 프로그램은?',
      a: '토크쇼',
      d: ['도', '투', '코', '그', '소'],
      tags: ['homonym', 'animal', 'd2'],
    },
    {
      id: 'c012',
      q: '마라탕이 정중하게 자기소개를 하면?',
      a: '맵니다',
      d: ['랩', '맴', '매', '리', '타'],
      tags: ['sound', 'food', 'd2'],
    },
    {
      id: 'c013',
      q: '보고 있으면 목이 턱 막히는 전개를 채소로 말하면?',
      a: '고구마',
      d: ['코', '그', '국', '무', '나'],
      tags: ['slang', 'food', 'd1'],
    },
    {
      id: 'c014',
      q: '안경 쓰고 마라탕집에 들어가면 만나는 귀신은?',
      a: '김서림',
      d: ['검', '감', '저', '사', '임'],
      tags: ['homonym', 'food', 'd3'],
    },
    {
      id: 'c015',
      q: '계산할 때만 화장실에 가는 친구에게서 보이는 각은?',
      a: '손절각',
      d: ['산', '순', '전', '잘', '낙'],
      tags: ['slang', 'money', 'd1'],
    },
    {
      id: 'c016',
      q: '말수가 하나도 없는 밑반찬은?',
      a: '무말랭이',
      d: ['물', '모', '발', '냉', '랑', '니', '리'],
      tags: ['compound', 'food', 'd2'],
    },
    {
      id: 'c017',
      q: '단톡방에서 제일 높은 단수는?',
      a: '눈치백단',
      d: ['문', '시', '지', '박', '탄'],
      tags: ['compound', 'device', 'd2'],
    },
    {
      id: 'c018',
      q: '볼 때마다 다이어트에 성공해 있는 것은?',
      a: '통장잔고',
      d: ['동', '총', '상', '전', '코'],
      tags: ['observation', 'money', 'd1'],
    },
    {
      id: 'c019',
      q: '치킨집에서 제일 부러운 손님은?',
      a: '닭살커플',
      d: ['달', '닮', '삵', '닥', '담', '거', '컵', '풀'],
      tags: ['homonym', 'food', 'd2'],
    },
    {
      id: 'c020',
      q: '자취방 책상 위에서 절대 사라지지 않는 별자리는?',
      a: '물병자리',
      d: ['불', '문', '명', '차', '니'],
      tags: ['compound', 'home', 'd3'],
    },
    {
      id: 'c021',
      q: '지갑을 열 때마다 안에서 불어오는 것은?',
      a: '찬바람',
      d: ['잔', '탄', '마', '밤', '남'],
      tags: ['homonym', 'money', 'd2'],
    },
    {
      id: 'c022',
      q: '회의 시간에만 유독 잘 되는 운동은?',
      a: '눈감기',
      d: ['문', '순', '남', '검', '지'],
      tags: ['homonym', 'work', 'd3'],
    },
    {
      id: 'c023',
      q: '장마철 빨래가 제일 듣기 싫어하는 말은?',
      a: '비온대',
      d: ['미', '시', '손', '언', '새', '태'],
      tags: ['sound', 'weather', 'd1'],
    },
    {
      id: 'c024',
      q: '자취방 침대 밑에서 자라는 야생동물은?',
      a: '먼지뭉치',
      d: ['번', '만', '미', '붕', '티'],
      tags: ['observation', 'home', 'd2'],
    },
  ],
};
